// Ported from case-desk src/components/BootstrapLoadingScreen.tsx (commit 1d18e32) per das-web § 14,
// 2026-08-18: skeleton with the final shell geometry so the workspace does not jump when it lands.
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { designTokens } from '../theme/tokens';

import { BrandMark } from './BrandMark';

type BootstrapLoadingScreenProps = {
  label: string;
};

export function BootstrapLoadingScreen({ label }: BootstrapLoadingScreenProps) {
  return (
    <Box aria-label={label} role="status" sx={{ display: 'flex', height: '100dvh', overflow: 'hidden' }}>
      <Box
        sx={{
          alignItems: 'flex-start',
          bgcolor: 'background.paper',
          borderRight: 1,
          borderColor: 'divider',
          display: 'flex',
          flexShrink: 0,
          justifyContent: 'center',
          pt: 1.25,
          width: designTokens.layout.navigationCollapsedWidth,
        }}
      >
        <BrandMark />
      </Box>
      <Stack spacing={1.5} sx={{ flexGrow: 1, minWidth: 0, overflow: 'hidden' }}>
        <Box
          sx={{
            alignItems: 'center',
            bgcolor: 'background.paper',
            borderBottom: 1,
            borderColor: 'divider',
            display: 'flex',
            minHeight: designTokens.layout.contentHeaderHeight,
            px: 2,
          }}
        >
          <Skeleton width={140} />
        </Box>
        <Stack spacing={1} sx={{ px: 2 }}>
          <Skeleton height={32} variant="rounded" width="45%" />
          <Skeleton height={32} variant="rounded" width="100%" />
          <Skeleton height={32} variant="rounded" width="100%" />
          <Skeleton height={32} variant="rounded" width="100%" />
        </Stack>
      </Stack>
    </Box>
  );
}
